module.exports = __webpack_public_path__ + "img/c6-m.16879f51.jpg";